import { useContext, useState } from 'react'

import { context } from './context'

/**
 * Provide a consistent, unique string for this component instance, by providing
 * an incrementing number with an optional prefix.
 *
 * Without a UniqueProvider, values are globally unique in execution context.
 *
 * With a UniqueProvider, values are unique inside the provider. This may prove
 * an advantage if running on both server and client, since IDs can be matched
 * during first render.
 */
export const useUnique = (prefix?: string) => {
	const unique = useContext(context)

	const [value] = useState(() => unique(prefix))

	return value
}
